import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { get, APIError } from '../services/crud'
import { ISource } from './typings'
import { ISearchResponse } from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.coreProduct.sources}`

export const getSources = createAsyncThunk<
  ISource[],
  void,
  { rejectValue: APIError }
>('source/get', async (_, thunkApi) => {
  const response = await get(baseUrl)
  if (response.ok) {
    const result: ISearchResponse<ISource> = await response.json()
    return result.items
  }
  return thunkApi.rejectWithValue(await response.json())
})
